module.exports = __webpack_public_path__ + "static/en-2-97ea5bda68ce18286ebd45d1c5ee8bcc.png";